<template>
  <div style="height: calc(100% - 52px);background: #fff">
    <div class="inspiration">
      <div class="middle">
        <h1>漏斗分析</h1>
        <img src="../../assets/images/not-finish.png" class="not-finish" alt="">
        <div class="not-finish-tips">即将完成开发，敬请期待</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: '',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'getLeftmenu'
    ])
  },
  mounted() {
  },
  created() {
  },
  methods: {
    ...mapMutations([
      'setLeftmenu'
    ])
  }
}
</script>
<style scoped>
.inspiration{
  background: #fff;
  width: 100%;
  height: calc(100% - 52px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.middle{
  width: 1200px;
  height: 600px;
}
.not-finish{
  display: block;
  width: 507px;
  height: 355px;
  margin: 50px auto 0;
}
.not-finish-tips{
  height: 28px;
  font-size: 28px;
  color: #666;
  margin: 0 auto;
}
.false-footer{
  width: 100%;
  font-size: 12px;
  color: #999;
  margin: 0 auto 0;
}
</style>
